// Preserve the homepage's 36-card pace across rows with different review counts.
window.NuerReviewMotion = {
  duration(host, distance, cardWidth, gap) {
    const style = getComputedStyle(host);
    const cycle = parseFloat(style.getPropertyValue('--nuer-review-reference-duration'));
    const count = parseFloat(style.getPropertyValue('--nuer-review-reference-count'));
    return distance / (cardWidth + gap) * cycle / count;
  },

  observePlayback(host, requiresMoving = false) {
    const button = host.querySelector('[data-motion-toggle]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    const sync = () => {
      host.toggleAttribute('data-motion-paused', userPaused || document.hidden);
      if (!button) return;
      button.hidden = reducedMotion.matches || (requiresMoving && !host.hasAttribute('data-moving'));
      button.setAttribute('aria-pressed', String(userPaused));
      const label = userPaused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
      if (button.textContent !== label) button.textContent = label;
    };
    const toggle = () => { userPaused = !userPaused; sync(); };
    button?.addEventListener('click', toggle);
    document.addEventListener('visibilitychange', sync);
    reducedMotion.addEventListener('change', sync);
    const observer = new IntersectionObserver(([entry]) => host.toggleAttribute('data-offscreen', !entry.isIntersecting));
    observer.observe(host);
    sync();
    return {
      sync,
      disconnect() {
        button?.removeEventListener('click', toggle);
        document.removeEventListener('visibilitychange', sync);
        reducedMotion.removeEventListener('change', sync);
        observer.disconnect();
      }
    };
  },

  observeCardHover(host, selector) {
    const onMove = (event) => {
      if (event.pointerType === 'touch') return;
      // Inert animation copies cannot be event targets, but still count visually.
      const hovered = Array.from(host.querySelectorAll(selector)).some((card) => {
        const rect = card.getBoundingClientRect();
        return event.clientX >= rect.left && event.clientX <= rect.right &&
          event.clientY >= rect.top && event.clientY <= rect.bottom;
      });
      if (host.hasAttribute('data-card-hovered') !== hovered) host.toggleAttribute('data-card-hovered', hovered);
    };
    const onLeave = () => host.removeAttribute('data-card-hovered');
    host.addEventListener('pointermove', onMove);
    host.addEventListener('pointerleave', onLeave);
    return () => {
      host.removeEventListener('pointermove', onMove);
      host.removeEventListener('pointerleave', onLeave);
      onLeave();
    };
  }
};
